import { useTranslation } from 'react-i18next';

const featuredCategories = [
  {
    name: 'Shoes',
    namePt: 'Sapatos',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20pair%20of%20cream%20leather%20sneakers%20placed%20on%20a%20warm%20terracotta%20ceramic%20tile%20surface%20with%20soft%20morning%20sunlight%20casting%20long%20delicate%20shadows%2C%20minimalist%20editorial%20product%20photography%20with%20linen%20fabric%20draped%20in%20background%2C%20warm%20neutral%20aesthetic&width=900&height=600&seq=feat-shoes-v4-z1u1&orientation=landscape',
    description: 'Tênis, sneakers e calçados casuais'
  },
  {
    name: 'Hoodies/Sweaters',
    namePt: 'Moletons',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Oversized%20chunky%20knit%20sweater%20in%20warm%20oatmeal%20color%20draped%20over%20a%20minimal%20wooden%20chair%20against%20a%20cream%20textured%20wall%2C%20soft%20diffused%20daylight%20from%20large%20window%2C%20cozy%20minimalist%20editorial%20fashion%20photography%20with%20organic%20fabric%20texture&width=600&height=400&seq=feat-hoodies-v4-u6p6&orientation=landscape',
    description: 'Moletons, blusas de frio e suéteres'
  },
  {
    name: 'T-Shirts',
    namePt: 'Camisetas',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Three%20soft%20cotton%20t-shirts%20in%20sage%20green%20warm%20beige%20and%20cream%20neatly%20stacked%20on%20a%20light%20oak%20surface%20with%20a%20small%20ceramic%20vase%20beside%2C%20natural%20sunlight%2C%20clean%20minimalist%20product%20photography&width=600&height=400&seq=feat-tshirts-v4-v7q7&orientation=landscape',
    description: 'Camisetas básicas e estampadas'
  },
  {
    name: 'Jackets',
    namePt: 'Jaquetas',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20beige%20trench%20coat%20elegantly%20hanging%20from%20a%20minimalist%20wooden%20wall%20hook%20against%20a%20textured%20warm%20plaster%20wall%2C%20soft%20directional%20natural%20lighting%2C%20editorial%20fashion%20photography%20with%20clean%20sophisticated%20composition&width=600&height=400&seq=feat-jackets-v4-w8r8&orientation=landscape',
    description: 'Jaquetas, casacos e blazers'
  },
  {
    name: 'Accessories',
    namePt: 'Acessórios',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Delicate%20gold%20chain%20necklace%20and%20minimalist%20rings%20artfully%20arranged%20on%20a%20smooth%20travertine%20surface%20with%20a%20single%20dried%20lavender%20stem%2C%20warm%20natural%20window%20light%2C%20editorial%20jewelry%20photography%20with%20refined%20minimal%20composition&width=600&height=400&seq=feat-accessories-v4-x9s9&orientation=landscape',
    description: 'Acessórios de moda e joias'
  },
  {
    name: 'Bags',
    namePt: 'Bolsas',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Structured%20cognac%20leather%20tote%20bag%20standing%20proudly%20on%20a%20minimalist%20cream%20pedestal%20with%20natural%20textured%20linen%20backdrop%2C%20soft%20directional%20lighting%20highlighting%20leather%20grain%2C%20editorial%20accessory%20photography%20with%20warm%20elegant%20aesthetic&width=600&height=400&seq=feat-bags-v4-y0t0&orientation=landscape',
    description: 'Bolsas, mochilas e malas'
  }
];

export default function FeatureGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight">
            Explore as <br />
            <span className="text-primary-500">Melhores Categorias</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {featuredCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative overflow-hidden rounded-xl cursor-pointer ${
                idx === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
              style={{ minHeight: idx === 0 ? '480px' : '220px' }}
            >
              <img
                src={cat.image}
                alt={cat.namePt}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                loading={idx < 2 ? 'eager' : 'lazy'}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-xl md:text-2xl font-heading font-semibold text-white mb-1">
                  {cat.namePt}
                </h3>
                <p className="text-sm text-white/70 hidden group-hover:block transition-all duration-300">
                  {cat.description}
                </p>
                <span className="inline-block mt-2 text-xs font-medium text-white/90 bg-white/10 backdrop-blur-sm px-3 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {t('categories.viewAll')} →
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}